import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PagesComponent } from './pages.component';
import {SuccessComponent} from "./success/success.component";
import {FailureComponent} from "./failure/failure.component";
import {VerifyComponent} from "./verify/verify.component";
import {NotFoundComponent} from "src/app/pages/not-found/not-found.component";
import { ConfigurationPageComponent} from "./configuration/configuration.component";
import { InstallationPageComponent } from './installation/installation-component';

const routes: Routes = [
  {
    path: '',
    component: PagesComponent,
    children: [
      {
        path: '',
        component: InstallationPageComponent
        //loadChildren: () => import('./installation/welcome-module.module').then(m => m.WelcomeModuleModule)
      },
      {
        path: 'success',
        component: SuccessComponent
      },
      {
        path: 'failure',
        component: FailureComponent
      },
      {
        path: 'install',
        component: InstallationPageComponent
      },
      {
        path: 'settings',
        component: ConfigurationPageComponent
      },
      /*{
        path: 'verify',
        component: VerifyComponent
      },*/
      {
        path: 'not-found',
        component: NotFoundComponent
      }
    ],
  },
  { path: '**', redirectTo: '/not-found', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
